import { Timestamp } from 'firebase/firestore';

export type WaitlistStatus = 'waiting' | 'notified' | 'seated' | 'removed';

export interface WaitlistEntry {
  id: string;
  name: string;
  phone?: string;
  status: WaitlistStatus;
  position: number; // Explicit position for manual reordering
  added_at: Timestamp;
  created_at?: Timestamp; // For backward compatibility with old entries
  user_id?: string; // Optional reference to users collection
  added_by?: 'self' | 'admin'; // Indicates how the player was added to waitlist
}

export interface CreateWaitlistEntryData {
  name: string;
  phone?: string;
  user_id?: string;
  added_by?: 'self' | 'admin';
}

export interface UpdateWaitlistEntryData {
  name?: string | undefined;
  phone?: string | undefined;
  status?: WaitlistStatus | undefined;
  added_by?: 'self' | 'admin' | undefined;
}

export const WAITLIST_STATUSES: WaitlistStatus[] = [
  'waiting',
  'notified',
  'seated', 
  'removed'
];

// Saved Player types for room-scoped contact storage
export interface SavedPlayer {
  id: string;
  name: string;
  phone?: string;
  phoneNormalized?: string; // Digits only for efficient partial matching search
  created_at: Timestamp;
  updated_at: Timestamp;
}

export interface CreateSavedPlayerData {
  name: string;
  phone?: string;
}

export interface UpdateSavedPlayerData {
  name?: string;
  phone?: string;
}